module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAABFklEQVQ4T+3USUoDURAG4C/OG/UMHsJhLzggxDmCSw/gXVx5AFFQnEFUcOFKPUUOoYIjtJS00JiO6cQsXNi7hn5f/1VUvZI2P6U2e0pJknS0E/0Hf9/N6OEmxrGGmxbJYWzhOsAqhvCI6RbQwC4xiGqAEzhBHx5S9LZg0pEUG8ATyl9jM4kj9DaBjuICgT1jFlfZOYxyD9GTolO4q5M0i71gPk1asykz2G+AjuE8TfaKhfT98995m1LGHrpzkgYWZfYjsCWcZauot3pz2EUX7hHlx85HssDeUMHp95b8tMuL2MmgcTMF9o4VHOf1t9HlsIxtdKaHA1vFQb2xagTGuSh/AwnW88os0sOCc137WZGETeF/H/wA55xwuHDgXfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/coupon/coupon_icon_down.png
// module id = W/FQ
// module chunks = 3